import { FC, ReactNode } from 'react'
import styled, { css } from 'styled-components'

type FooterContentProps = {
  isWide: boolean
  children: ReactNode
}
export const FooterContent: FC<FooterContentProps> = ({ isWide, children }) => {
  return <StyledSelectWrap isWide={isWide}>{children}</StyledSelectWrap>
}

export const StyledSelectWrap = styled.div<{ isWide: boolean }>`
  margin-bottom: 40px;
  ${({ isWide }) =>
    isWide &&
    css`
      width: 100%;
      max-width: 673px;
      @media (max-width: 767px) {
        width: 93%;
      }
    `}

  @media (max-width: 767px) {
    margin-bottom: 20px;
  }
`
